module.exports = __webpack_public_path__ + "img/lait.3d5b755e.svg";